import { initialStateOptions } from '@/utils/pagination-utils';

import CotacaoViewOptions from '@/enums/cotacao-view-options';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  selectedStatus: null,
  searchText: null,
  empresa: null,
  localEntrega: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  fornecedor: [],
  dataFinal: null,
  dataInicial: null,
  grupo: [],
  situacao: [],
  listOptions: initialStateOptions(),
  viewOption: CotacaoViewOptions.keys.POR_COTACAO.key,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
